
import { clusterService } from "../../services/cluster.service";
import { taskService } from "../../services/task.service";
import { trackService } from "../../services/track.services";
import { STORE_CONSTANTS } from '../../common/store.constants';
import { dateService } from '../../services/date.service';
import { sum } from 'lodash';

const MUTATION_NAMES = STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITHOUT_NAMESPACE;

const dailyTasks = {
    namespaced: true,
    actions: {
        setStaffDailyTasks (context, data) {
            context.commit(MUTATION_NAMES.SET_IS_EXECUTING, true);
            return new Promise((resolve, reject) => {
                let unsortedTasks = data.features.filter((feature) => {
                    return (
                        feature.properties.tag === "task" ||
                        feature.properties.tag === "suspect"
                    );
                })
                .map((feature) => {
                    return feature.properties;
                });

                // order by allTasks
                let allTasks = unsortedTasks.sort(
                  (a, b) => b.DateCOMPLETEDMilli - a.DateCOMPLETEDMilli
                );

                // get suspect task count
                if (allTasks) {
                    let susCount = allTasks.filter((feature) => {
                        return feature.tag === "suspect";
                  }).length;
                  context.commit(MUTATION_NAMES.SET_SUSPECT_TASK_COUNT, susCount);
                }
                // get total task count
                if (allTasks) {
                    context.commit(MUTATION_NAMES.SET_TASK_COUNT, allTasks.length);
                }

                taskService.getTaskForSelectedStaffId(data.criteria).then(function (response) {
                    let tasks = [];
                    if (response && response.data) {
                        tasks = response.data;
                    }

                    const len = (!tasks) ? 0 : tasks.length;
                    const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                    context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                    resolve({ selectedRow: selItem, allTasksCount: len });
                })
                .catch((err) => {
                    reject(err);
                }).finally(() =>{
                    context.commit(MUTATION_NAMES.SET_IS_EXECUTING, false);
                });
            });
        },
        queryAllStaffTasks(context, criteria) {
            // context.commit('setAllStaffTasks', tasks);
        },
        getTasksByStatus(context, criteria) {
            return new Promise((resolve, reject) => {
                let tasks = [];
                taskService.getTasksByStatus(criteria).then(function (response) {
                        if (response && response.data) {
                            tasks = response.data;
                        }

                        const len = (!tasks) ? 0 : tasks.length;
                        const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                        context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                        resolve({ selectedRow: selItem, allTasksCount: len });
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        },
        getTasksByStaffAndStatus(context, criteria) {
            return new Promise((resolve, reject) => {
                let tasks = [];
                taskService.getTasksByStaffAndStatus(criteria).then(function (response) {
                    if (response && response.data) {
                        tasks = response.data;
                    }

                    const len = (!tasks) ? 0 : tasks.length;
                    const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                    context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                    resolve({ selectedRow: selItem, allTasksCount: len });
                })
                .catch(function (err) {
                    reject(err);
                });
            });
        },
        getAllStaffDailySummary(context, criteria) {
            return new Promise((resolve, reject) => {
                let tasks = [];
                clusterService.getAllStaffDailySummary(criteria).then(function (response) {
                  if (response && response.data) {
                    tasks = response.data;
                  }

                  const len = (!tasks) ? 0 : tasks.length;
                  const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                  context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                  resolve({ selectedRow: selItem, allTasksCount: len });
                })
                .catch(function (err) {
                  reject(err);
                });
            });
        },
        getStaffDailySummary(context, criteria) {
            return new Promise((resolve, reject) => {
                let dailyTaskSummary = {};
                clusterService.getStaffDailySummary(criteria).then(function (response) {
                  if (response && response.data) {
										const summary = response.data.features[0].properties
										console.log('summary: ', summary)
                    dailyTaskSummary.manager = summary ? summary.Manager : null
                    dailyTaskSummary.supervisor = summary ? summary.Supervisor : null
                    dailyTaskSummary.travelled = summary ? summary.Travelled + "" : null
                    dailyTaskSummary.travelTime = summary ? summary.TravelTime.toString().slice(0, 2) + 'h ' + summary.TravelTime.toString().slice(3, 5) + 'm ' + summary.TravelTime.toString().slice(6, 8) + 's' : null
                    dailyTaskSummary.gpsPoints = summary ?  summary.Points : null
                    dailyTaskSummary.dayStart = summary ? summary.DateStart.slice(5) : null
                    dailyTaskSummary.dayEnd = summary ? summary.DateEnd.slice(5) : null
                    dailyTaskSummary.laptopTravelled = summary ? summary.TravelledLaptop : null
                    dailyTaskSummary.laptopTravelTime = summary ? summary.TravelTimeLaptop.toString().slice(0, 2) + 'h ' + summary.TravelTimeLaptop.toString().slice(3, 5) + 'm ' + summary.TravelTimeLaptop.toString().slice(6, 8) + 's' : null
                    dailyTaskSummary.laptopGpsPoints = summary ? summary.PointsLaptop : null
                    dailyTaskSummary.laptopDayStart = summary ? summary.DateStartLaptop.slice(5) : null
                    dailyTaskSummary.laptopDayEnd = summary ? summary.DateEndLaptop.slice(5) : null
                    dailyTaskSummary.phoneTravelled = summary ? summary.TravelledPhone + "" : null
                    dailyTaskSummary.phoneTravelTime = summary ? summary.TravelTimePhone.toString().slice(0, 2) + 'h ' + summary.TravelTimePhone.toString().slice(3, 5) + 'm ' + summary.TravelTimePhone.toString().slice(6, 8) + 's' : null
                    dailyTaskSummary.phoneGpsPoints = summary ? summary.PointsPhone : null
                    dailyTaskSummary.phoneDayStart = summary ? summary.DateStartPhone.slice(5) : null
                    dailyTaskSummary.phoneDayEnd = summary ? summary.DateEndPhone.slice(5) : null
                  }
                  context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS_SUMMARY, dailyTaskSummary);
                  resolve({ summary: dailyTaskSummary });
                })
                .catch(function (err) {
                    reject(err);
                });
            });
        },
        getClustersForManager(context, criteria) {
            return new Promise((resolve, reject) => {
                let tasks = [];
                clusterService.getClustersForManager(criteria).then(function (response) {
                  if (response && response.data) {
                    tasks = response.data;
                  }

                  const len = (!tasks) ? 0 : tasks.length;
                  const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                  context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                  resolve({ selectedRow: selItem, allTasksCount: len });
                })
                .catch(function (err) {
                  reject(err);
                })
            });
        },
        getTasksForSpid(context, criteria) {
            return new Promise((resolve, reject) => {
                let tasks = [];
                taskService.getTasksForSpid(criteria).then(function (response) {
                  if (response && response.data) {
                    tasks = response.data;
                  }

                  const len = (!tasks) ? 0 : tasks.length;
                  const selItem = (!tasks || len === 0 ) ? null : tasks[0];
                  context.commit(MUTATION_NAMES.SET_STAFF_DAILY_TASKS, tasks);
                  resolve({ selectedRow: selItem, allTasksCount: len });
                })
                .catch(function (err) {
                  reject(err);
                })
            });
        },

        getStaffDailyLastGpsTrack(context, criteria) {
            return new Promise((resolve, reject) => {
                let gpsTrackInfo = {};
                trackService.getStaffLastReceivedGpsTrack(criteria).then(function (response) {
                  if (response && response.data) {
                    gpsTrackInfo.device = response.data.features[0].properties.Device;
                    gpsTrackInfo.source = response.data.features[0].properties.Source;
                    gpsTrackInfo.lat = response.data.features[0].properties.Lat;
                    gpsTrackInfo.lon = response.data.features[0].properties.Lon;
                    gpsTrackInfo.date = response.data.features[0].properties.Time;
                  }

                  context.commit(MUTATION_NAMES.SET_STAFF_DAILY_LAST_GPS_TRACK, gpsTrackInfo);
                  resolve({ gpsTrackInfo: gpsTrackInfo });
                })
                .catch(function (e) {
                  reject(e);
                });
            });
        }
    },
    getters: {
        getAllTasks: (state) => {
            return state.allTasks;
        },
        getSuspectTaskCount: (state) => {
            return state.suspectTasksCount;
        },
        getTotalTaskCount: (state) => {
            return state.totalTasksCount;
        },
        getAllStaffTasks: (state) => {
            return state.allStaffTasks;
        },
        getStaffDailyTaskList: (state) => {
            return state.staffDaily.tasks;
        }
    },
    mutations: {
			setSuspectTaskCount(state, data) {
					// Vue.set(state, 'suspectTasksCount', data);
					state.suspectTasksCount = data
			},
			setTaskCount(state, data) {
					// Vue.set(state, 'totalTasksCount', data);
					state.totalTasksCount = data
			},
			setStaffDailyTasks(state, tasks) {
					// Vue.set(state.staffDaily, 'tasks', tasks);
					state.staffDaily.tasks = tasks
			},
			setStaffDailySummary(state, summaryInfo) {
					// Vue.set(state.staffDaily, 'summary', summaryInfo);
					state.staffDaily.summary = summaryInfo
			},
			setStaffDailyLastGpsTrack(state, gpsTrackInfo) {
					// Vue.set(state.staffDaily, 'lastGpsTrack', gpsTrackInfo);
					state.staffDaily.lastGpsTrack = gpsTrackInfo
			},
			clearStaffDailyInfo(state) {
				//  Vue.set(state, 'staffDaily', {
				//       tasks: [],
				//       summary: null,
				//       lastGpsTrack: null,
				//   });
					state.staffDaily.tasks = []
					state.staffDaily.summary = null
					state.staffDaily.lastGpsTrack = null
					// Vue.set(state, 'suspectTasksCount', 0);
					state.suspectTasksCount = 0
					// Vue.set(state, 'totalTasksCount', 0);
					state.totalTasksCount = 0
			},
			setIsExecuting(state, isExecuting) {
					// Vue.set(state, 'isExecuting', isExecuting);
					state.isExecuting = isExecuting
			}
	},
    state: {
        staffDaily : {
            tasks: null,
            summary: null,
            lastGpsTrack: null,
        },
        suspectTasksCount: 0,
				totalTasksCount: 0,
        taskCount: 0,
        isExecuting: false,
    }
};

export default dailyTasks;
